<template>
  <!-- 表单标签对齐方式设置
       @author: liuguisheng
       @date: 2019-11-6
   -->
  <div class="setting-item">
    <el-form-item label="标签文本对齐"> 
      <el-radio-group v-model="labelTextPosition"
                      size="small">
        <el-radio-button  v-for="(el,index) in labelTextPositionList"
                          :key="index"
                          :label="el.label"> {{el.value}}
        </el-radio-button>
      </el-radio-group>
    </el-form-item>
  </div>
</template>

<script>

// 引入标签位置配置字典 { labelTextPositionList:标签位置配置列表 } 
import { labelTextPositionList } from '@/assets/js/config_dictionary.js';
// 导入value监听混入
import mixValueWatch from '@/mixins/common/mix_value_watch.js';
// 导入计算属性映射方法
import { mapComputed } from '@/mixins/common/mix_value_watch.js';

export default {
  mixins: [ mixValueWatch ],
  data () {
    return {
      // 标签位置配置字典
      labelTextPositionList
    }
  },
  computed: {
    /** @name 最大输入文本长度
     *  @description 将 labelTextPosition 字段映射到当前 labelTextPosition 计算属性
     *  @return { Object }
     *  @author 王汝鹏
     *  @version 2019-09-25
     */
    ...mapComputed({
      labelTextPosition: { 
        parent: i => i.styleOption,
        attr: "labelTextPosition"
      }
    })
  },
}
</script>


// WEBPACK FOOTER //
// src/components/Setting/style_setting/SettingLabelTextPosition.vue